// Tipos que contam como celular. O Phoenix manda o código por SMS para o último deles, e é ele que o
// Thor mostra no campo Celular do perfil. Fixo e telefone sem tipo ficam de fora (TIC2-16047).
export const MOBILE_PHONE_TYPES = ["mobile", "whatsapp"];

export function getSmsPhone(phones) {
    return (phones ?? [])
        .filter((phone) => MOBILE_PHONE_TYPES.includes(phone.type))
        .reduce(
            (latest, phone) => (latest === null || phone.id > latest.id ? phone : latest),
            null
        );
}
